import React from 'react';
import { BackendTiles } from '../../../backend/BackendTiles';
import { readConfiguration, canUseO19Settings } from '../../../backend/runtime';
import { LegacyDashboardContent } from './LegacyDashboardContent';

export const DashboardContent = () => canUseO19Settings(readConfiguration().profiles)
  ? <BackendTiles /> : <LegacyDashboardContent />;
